export default __webpack_public_path__ + "static/media/add.e9e92bd3.svg";